/* =====================================================================
   accessory-bundle.js
   Логіка секції "Додай аксесуари" — власний код, без сторонніх застосунків.

   Що робить:
   1. Клік на круглий свотч — перемикає виділення (обідок) на клікнутому
      свотчі, оновлює ціну і "поточний" варіант для цієї картки, і (як в
      Adoric) підміняє ВЕЛИКЕ фото товару зверху картки. Джерело великого
      фото (рахується в Liquid, приходить як data-main-image):
        1) справжнє фото цього варіанту в Shopify, якщо воно там
           призначене (Admin → Товар → Variants → фото варіанту);
        2) якщо його немає — фото, завантажене для цього свотча в
           налаштуваннях блоку (те саме, що й іконка свотча);
        3) інакше — загальне фото товару.
      Більшість ваших товарів не мають фото на рівні варіанту в Shopify,
      тож на практиці найчастіше спрацьовує пункт 2 — велике фото просто
      збігається з фото свотча, і це очікувано.
   2. Клік на "Додати +" — додає ПОТОЧНИЙ обраний варіант ЦІЄЇ картки в
      кошик через стандартний Shopify AJAX /cart/add.js. Оскільки весь код
      наш власний, тут немає жодного ризику додати не той товар — variant id
      завжди береться з того самого свотча, який зараз обраний на екрані,
      і немає ніякого редіректу на /cart (ми його просто не викликаємо).

   ПЕРЕКЛАД: усі підписи кнопки ("Додати +", "Додаємо…", "Додано ✓" тощо)
   НЕ зашиті тут у коді — вони передаються з Liquid через data-label-*
   атрибути (а там беруться з locales/*.json через фільтр `| t`), тож
   автоматично показуються мовою вітрини. Тексти нижче — лише запасний
   варіант на випадок, якщо переклад не знайдено.
   ===================================================================== */
(function () {
  'use strict';

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Наші власні лічильники (якщо десь у темі є [data-cart-count]) —
        // просте число текстом, це безпечно перезаписати напряму.
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () {});

    // Значок кошика в шапці (.cart-count-bubble) — окремо, і НЕ через
    // простий textContent. З'ясувалось: у цій темі #cart-icon-bubble
    // (сама іконка кошика) рендериться з умовою "якщо кошик не
    // порожній" — тобто поки в кошику 0 товарів, елемента .cart-count-bubble
    // взагалі НЕМАЄ в DOM, і querySelector його просто не знаходить (тому
    // після ПЕРШОГО товару бейдж не з'являвся). А коли він є —
    // всередині складніша розмітка (окремий <span> для числа й окремий
    // visually-hidden <span> для скрінрідерів), яку el.textContent = ...
    // стирає й ламає. Тому робимо так само, як сама тема Dawn: перезапитуємо
    // свіжу HTML-розмітку шапки через Section Rendering API Shopify і
    // підміняємо нею стару — це і створює бейдж, коли його ще не було, і
    // коректно оновлює число.
    syncHeaderCartIcon();
  }

  function syncHeaderCartIcon() {
    var liveIcon = document.getElementById('cart-icon-bubble');
    if (!liveIcon) return; // в цій темі немає такого елемента — нічого робити

    fetch(window.location.pathname + '?sections=header')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.header;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newIcon = doc.getElementById('cart-icon-bubble');
        var currentIcon = document.getElementById('cart-icon-bubble');
        if (newIcon && currentIcon) {
          currentIcon.innerHTML = newIcon.innerHTML;
        }
      })
      .catch(function () {});
  }

  function initCard(card) {
    var addBtn = card.querySelector('[data-accessory-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var image = card.querySelector('[data-accessory-image]');
    var priceSale = card.querySelector('[data-price-sale]');
    var priceCompare = card.querySelector('[data-price-compare]');
    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-accessory-swatch]'));

    function label(key, fallback) {
      if (!addBtn) return fallback;
      var v = addBtn.getAttribute('data-label-' + key);
      return v || fallback;
    }

    var IDLE_LABEL = label('idle', 'Додати +');
    var ADDING_LABEL = label('adding', 'Додаємо…');
    var ADDED_LABEL = label('added', 'Додано ✓');
    var ERROR_LABEL = label('error', 'Помилка, спробуйте ще');
    var UNAVAILABLE_LABEL = label('unavailable', 'Немає в наявності');

    function selectSwatch(btn) {
      swatches.forEach(function (s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      card.setAttribute('data-current-variant-id', btn.getAttribute('data-variant-id'));

      // Як в Adoric: головне фото підмінюється, але береться саме з
      // реального фото варіанту (data-main-image), а не з фото свотча.
      var mainImgUrl = btn.getAttribute('data-main-image');
      if (image && mainImgUrl) {
        image.src = mainImgUrl;
        image.srcset = '';
      }

      if (priceSale) {
        priceSale.innerHTML = btn.getAttribute('data-price-sale-html') || priceSale.innerHTML;
      }
      if (priceCompare) {
        var cmp = btn.getAttribute('data-price-compare-html');
        if (cmp) {
          priceCompare.innerHTML = cmp;
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }

      var available = btn.getAttribute('data-available') === 'true';
      if (addBtn) {
        if (available) {
          addBtn.removeAttribute('data-state');
          addBtn.setAttribute('data-state', 'idle');
          if (addLabel) addLabel.textContent = IDLE_LABEL;
        } else {
          addBtn.setAttribute('data-state', 'unavailable');
          if (addLabel) addLabel.textContent = UNAVAILABLE_LABEL;
        }
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-available') !== 'true') return;
        selectSwatch(btn);
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.getAttribute('data-state') === 'loading' || addBtn.getAttribute('data-state') === 'unavailable') return;

        var variantId = card.getAttribute('data-current-variant-id');
        if (!variantId) return;

        addBtn.setAttribute('data-state', 'loading');
        if (addLabel) addLabel.textContent = ADDING_LABEL;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error((err && err.description) || 'add_failed');
              });
            }
            return res.json();
          })
          .then(function () {
            updateCartCount();
            addBtn.setAttribute('data-state', 'done');
            if (addLabel) addLabel.textContent = ADDED_LABEL;
            setTimeout(function () {
              addBtn.setAttribute('data-state', 'idle');
              if (addLabel) addLabel.textContent = IDLE_LABEL;
            }, 1200);
          })
          .catch(function (err) {
            addBtn.setAttribute('data-state', 'error');
            if (addLabel) addLabel.textContent = ERROR_LABEL;
            console.warn('[accessory-bundle] add to cart failed:', err && err.message);
            setTimeout(function () {
              addBtn.setAttribute('data-state', 'idle');
              if (addLabel) addLabel.textContent = IDLE_LABEL;
            }, 1600);
          });
      });
    }
  }

  function initDots(root) {
    var track = root.querySelector('[data-accessory-track]');
    var dotsWrap = root.querySelector('[data-accessory-dots]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-accessory-dot]'));
    if (!track || dots.length < 2) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-accessory-card]'));
    if (!cards.length) return;

    // Крапки потрібні, лише якщо картки реально не влазять в один екран
    // (є що гортати). На десктопі кількість видимих карток залежить від
    // ширини блока, тому стежимо через ResizeObserver, а не рахуємо
    // один раз при завантаженні.
    function updateVisibility() {
      if (!dotsWrap) return;
      var canScroll = track.scrollWidth - track.clientWidth > 2;
      dotsWrap.hidden = !canScroll;
    }

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    // Позиція лівого краю картки всередині прокручуваного вмісту треку
    // (не залежить від поточного scrollLeft — рахуємо через getBoundingClientRect,
    // щоб не покладатись на offsetParent).
    function cardOffset(card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function closestIndex() {
      var pos = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(cardOffset(card) - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setActive(closestIndex());
          ticking = false;
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        track.scrollTo({ left: cardOffset(card), behavior: 'smooth' });
      });
    });

    setActive(0);
    updateVisibility();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        updateVisibility();
      });
      ro.observe(track);
    } else {
      window.addEventListener('resize', updateVisibility);
    }
  }

  // Переносить секцію "Додай аксесуари" в позицію блока-якоря "Додай
  // аксесуари (позиція)" — ТІЛЬКИ на мобільному (щоб стояла під кнопкою
  // купівлі, над акордеонами). На десктопі секція лишається/повертається
  // туди, де її додано через "Add section" (наприклад, над відгуками) —
  // там зазвичай досить місця для сітки в кілька колонок, а всередині
  // вузької колонки товару поруч з акордеонами сітці було б тісно.
  //
  // Межа мобільний/десктоп — 749px, як і в решті теми. Слухаємо зміну
  // цієї межі (matchMedia), тож перенесення коректно спрацює і назад, якщо
  // хтось змінює розмір вікна browser (напр. орієнтація екрана).
  function initRelocation(root) {
    var wrapper = root.closest('.shopify-section') || root;

    if (wrapper.__abApply) {
      // Вже ініціалізовано раніше (напр. повторний виклик boot() з
      // редактора теми) — просто застосувати поточний стан ще раз.
      wrapper.__abApply();
      return;
    }

    var anchor = document.querySelector('[data-accessory-bundle-anchor]');
    if (!anchor) return; // якоря немає в темі — нічого не переносимо

    // Запам'ятовуємо, де секція стояла спочатку (до будь-яких
    // переміщень), щоб було куди повернути її на десктопі.
    wrapper.__abOriginalParent = wrapper.parentNode;
    wrapper.__abOriginalNextSibling = wrapper.nextSibling;

    var mq = window.matchMedia('(max-width: 749px)');

    function apply() {
      var currentAnchor = document.querySelector('[data-accessory-bundle-anchor]');
      if (!currentAnchor) return;

      if (mq.matches) {
        // Мобільна версія — під кнопку купівлі, над акордеони. Прибираємо
        // page-width: там уже є власні відступи колонки товару, і зайвий
        // page-width лише додав би невідповідний відступ по боках.
        root.classList.remove('page-width');
        if (wrapper.previousElementSibling !== currentAnchor) {
          currentAnchor.insertAdjacentElement('afterend', wrapper);
        }
      } else {
        // Десктоп — повертаємо туди, де секцію додано спочатку, і
        // повертаємо page-width, щоб блок мав такі самі бічні відступи й
        // центрування, як решта повноширинних секцій сторінки (без цього
        // блок розтягувався б в один суцільний ряд від краю до краю).
        root.classList.add('page-width');
        var atOriginalSpot =
          wrapper.parentNode === wrapper.__abOriginalParent &&
          wrapper.nextSibling === wrapper.__abOriginalNextSibling;
        if (!atOriginalSpot) {
          if (
            wrapper.__abOriginalNextSibling &&
            wrapper.__abOriginalNextSibling.parentNode === wrapper.__abOriginalParent
          ) {
            wrapper.__abOriginalParent.insertBefore(wrapper, wrapper.__abOriginalNextSibling);
          } else {
            wrapper.__abOriginalParent.appendChild(wrapper);
          }
        }
      }
    }

    wrapper.__abApply = apply;

    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply); // старіші браузери
    }

    apply();
  }

  // На десктопі блок має закінчуватись РІВНО там, де закінчується сама
  // картка товару (колонка фото зліва, колонка опису/акордеонів справа) —
  // тобто збігатись з тими самими межами, що й на скріншотах позначені
  // червоними лініями. Проблема в тому, що generic-клас .page-width дає
  // ЗАГАЛЬНИЙ відступ теми, а секція товару (main-product) на цьому сайті
  // використовує СВІЙ, більший відступ (власне налаштування "бічні
  // відступи" саме цієї секції) — тому .page-width сам по собі не
  // гарантує однакову ширину з .product.
  //
  // Замість того, щоб вгадувати конкретне число пікселів (яке залежить
  // від налаштувань теми і може змінитись), просто вимірюємо, де реально
  // намальована .product (ліва межа фото — права межа акордеонів), і
  // виставляємо такий самий відступ інлайновим стилем (він завжди
  // переважає над .page-width у каскаді, незалежно від специфічності).
  // Якщо .product на сторінці немає (не сторінка товару) — нічого не
  // форсуємо, лишається звичайний .page-width.
  function initDesktopBoundsSync(root) {
    if (root.__abBoundsSyncInit) return;
    root.__abBoundsSyncInit = true;

    var product = document.querySelector('.product');
    if (!product) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      if (mq.matches) {
        // Мобільна версія / позиція якоря — тут працюють власні налаштування
        // "Відступи секції" (--ab-padding-left/right), інлайн не потрібен.
        root.style.removeProperty('padding-left');
        root.style.removeProperty('padding-right');
        return;
      }
      var sectionRect = root.getBoundingClientRect();
      var productRect = product.getBoundingClientRect();
      if (!sectionRect.width) return;
      var left = Math.max(0, Math.round(productRect.left - sectionRect.left));
      var right = Math.max(0, Math.round(sectionRect.right - productRect.right));
      root.style.setProperty('padding-left', left + 'px');
      root.style.setProperty('padding-right', right + 'px');
    }

    sync();

    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        sync();
      });
      ro.observe(product);
      ro.observe(root);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  function boot() {
    document.querySelectorAll('.accessory-bundle').forEach(initRelocation);
    document.querySelectorAll('.accessory-bundle').forEach(initDesktopBoundsSync);
    document.querySelectorAll('[data-accessory-card]').forEach(initCard);
    document.querySelectorAll('.accessory-bundle').forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: коли редактор секцій перемальовує/додає блок,
  // ініціалізуємо нові картки заново.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();